var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"white--text text-none headline linear-button-background font-weight-bold pl-12 pr-12",attrs:{"depressed":"","rounded":"","ripple":"","large":""},on:{"click":_vm.buttonClicked}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }